<template>
  <UIDialog
    :is-open
    :z-index
    :title
    @close="handleClose"
  >
    <AddAccountForm
      placeholder="Chose qfx or ofx file"
      :loader="LinkedDataManualLoader.OFX"
      accept=".qfx,.ofx"
      @close="handleClose"
      @cancel="handleCancel"
    />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { LinkedDataManualLoader, ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import AddAccountForm from './AddAccountForm.vue'

type Props = {
  modal: ModalClass<any>
  isImport?: boolean
}


type Emits = {
  cancel: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const title = computed(
  () => `${props.isImport ? 'Import' : 'Add'} OFX Accounts`,
)

const handleClose = () => {
  props.modal.close()
}

const handleCancel = () => {
  handleClose()
  emit('cancel')
}
</script>
